"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.idfn = void 0;
var idfn = function (e) { return e; };
exports.idfn = idfn;
